<template>
<div class="mu-calendar-monthday-content" style="height: 260px">
  <div class="mu-calendar-monthday-row" :key="i"  v-for="week, i in weeksArray" style="height: 50px">
    <day-button @click="handleClick(item)" v-for="item, j in week" :key="'dayButton' + i + '' + j" :selected="equalsDate(item.date)" :date="item.date" :text="item.text"></day-button>
  </div>
</div>
</template>

<script>
import dayButton from './dayButton'
import * as dateUtils from './dateUtils'
export default {
  props: {
    displayDate: {
      type: Date
    },
    firstDayOfWeek: {
      type: Number,
      default: 1
    },
    selectedDate: {
      type: Date
    },
    multiple: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    let weeksArray = dateUtils.getWeekArray(this.displayDate || new Date(), this.firstDayOfWeek)
    weeksArray = weeksArray.map(item => {
      return item.map(day => {
        let array = this.multiple.filter(o => {
          o.date.valueOf() === (day ? day.valueOf() : 0)
          if (!day) return false
          if (o.date.getFullYear() === day.getFullYear() && o.date.getMonth() === day.getMonth() && o.date.getDate() === day.getDate()) return true
        })
        if (array.length) {
          return array[0]
        } else {
          return {
            date: day,
            text: null
          }
        }
      })
    })
    return {
      weeksArray: weeksArray
    }
  },
  methods: {
    equalsDate (date) {
      return dateUtils.isEqualDate(date, new Date())
    },
    handleClick (date) {
      if (date) this.$emit('selected', date)
    }
  },
  components: {
    'day-button': dayButton
  }
}
</script>



// WEBPACK FOOTER //
// src/components/NewDatePicker/calendarMonth.vue